import React, { FC, ReactElement, useRef } from 'react';
import {useSelector} from 'react-redux';
import Swiper from 'react-id-swiper';
import { goNext, goPrev } from '../../../../../helpers/swiper';
import Icon from '../../../../Icon';
import {internalizationState, ParamsDto} from '../../../../../stores/reducers/sections';
import localeFieldResolver from '../../../../../helpers/locale-field-finder';
import cns from 'classnames';

interface Props {
  speakers: any[];
  allowTargetBeforeStart: boolean;
  questionModalhandler: CallableFunction;
  viewParams?: any;
}

const HorizontalView: FC<Props> = ({ speakers, viewParams, allowTargetBeforeStart, questionModalhandler }): ReactElement => {
  const { activeLangState } = useSelector(internalizationState);
  const localizeData = {
    askQuestion_ru: 'Задать вопрос',
    askQuestion_en: 'Ask a Question',
  };
  const localizedName = (field: string): string | string[] => localeFieldResolver(localizeData, field, activeLangState);

  const photoRoundedParam = viewParams?.find((param: ParamsDto) => param.key === 'isSpeakerRounded') || '';
  const cardsQuantityParams = viewParams?.find((param: ParamsDto) => param.key === 'cardQuantity') || '';

  const swiperRef = useRef<any>();
  const swiperParams = {
    watchOverflow: true,
    slidesPerView: parseInt(cardsQuantityParams.value) || 3,
    // slidesPerView: 'auto' as 'auto',
    spaceBetween: 40,
    shouldSwiperUpdate: true,
    rebuildOnUpdate: true,
    breakpoints: {
      320: {
        slidesPerView: 1,
        spaceBetween: 20
      },
      480: {
        slidesPerView: 2,
        spaceBetween: 20
      },
      680: {
        slidesPerView: 3,
        spaceBetween: 30
      },
      860: {
        slidesPerView: parseInt(cardsQuantityParams.value) || 3,
        spaceBetween: 40
      }
    },
  };

  return (
    speakers && speakers.length ?
      <div className="speakers-horizontal">
        <Swiper
          ref={swiperRef}
          {...swiperParams}
        >
          {
            speakers.map((speaker: any, index: number) => (
              <div
                className="speakers-horizontal__speaker"
                key={index}
              >
                <div className={cns(
                    'speakers-horizontal__speaker__image',
                    photoRoundedParam.checked && 'rounded-photo'
                  )}
                >
                  <img src={speaker.photo} alt={ localeFieldResolver(speaker, 'fullnameRu', activeLangState) } />
                </div>
                <p className="speakers-horizontal__speaker__name">
                  { localeFieldResolver(speaker, 'fullnameRu', activeLangState) }
                </p>
                <p className="speakers-horizontal__speaker__description">
                  { localeFieldResolver(speaker, 'descriptionRu', activeLangState) }
                </p>
                {
                  allowTargetBeforeStart &&
                  <button
                    className="speaker-item__question-btn c-accent"
                    style={{
                      alignSelf: 'flex-start',
                    }}
                    onClick={() => questionModalhandler(`${localeFieldResolver(speaker, 'fullnameRu', activeLangState)}:`)}
                  >
                    <svg className="fill-accent" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M8 0C3.589 0 0 3.589 0 8V15.5C0 15.776 0.224 16 0.5 16H8C12.411 16 16 12.411 16 8C16 3.589 12.411 0 8 0ZM8.5 10H4.5C4.224 10 4 9.776 4 9.5C4 9.224 4.224 9 4.5 9H8.5C8.776 9 9 9.224 9 9.5C9 9.776 8.776 10 8.5 10ZM11.5 7H4.5C4.224 7 4 6.776 4 6.5C4 6.224 4.224 6 4.5 6H11.5C11.776 6 12 6.224 12 6.5C12 6.776 11.776 7 11.5 7Z" fill="#4EAC93"/>
                    </svg>
                    <span>{ localizedName('askQuestion_ru') }</span>
                  </button>
                }
              </div>
            ))
          }
        </Swiper>
        <div className="slider-nav speakers-horizontal__nav hidden-mobile">
          <button className="slider-nav__prev speakers-horizontal__nav__btn" type="button" onClick={() => goPrev(swiperRef)}>
            <Icon name="md-arr-left" />
          </button>
          <button className="slider-nav__next speakers-horizontal__nav__btn" type="button" onClick={() => goNext(swiperRef)}>
            <Icon name="md-arr-right" />
          </button>
        </div>
        {/* <div className="speakers-horizontal__dots">
          {
            speakers.map((speaker: any, index: number) => (
              <div key={index} className="slider-dot"></div>
            ))
          }
        </div> */}
      </div>
    :
      <></>
  )
}

export default HorizontalView;
